import { contractApi } from "@/axios";
//获取页面
export function getContractSignPage(params, data) {
    return contractApi({
        url: '/contract-sign/page',
        method: 'post',
        data: data,
        params: params
    })
}

//合同签订 申请
export function contractSignApply(data) {
    return contractApi({
        url: '/contract-sign/apply',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data' // 指定内容类型为 form-data
        }
    })
}

//合同签订 审核
export function signAudit(data) {
    return contractApi({
        url: '/contract-sign/audit',
        method: 'put',
        data: data
    })
}
//获取合同签署文件下载链接
export function getDownloadLink(id) {
    return contractApi({
        url: '/contract-sign/get-download-path/' + id,
        method: 'get'
    })
}
//撤销签署
export function revokeSign(id) {
    return contractApi({
        url: `/contract-sign/revoke/${id}`,
        method: 'put',
    })
}